<template>
  <svg-icon :name="chargeIcon" class="svg-icon-without-hover mr-2" :width="28">
    <template #additionalContent>
        <text x="13" y="12" class="connection-info" fill="white" text-anchor="middle">{{ levelText }}</text>
    </template>
  </svg-icon>
</template>

<script>

const BATTERY_CONFIG = {
  DEVICE: {
    thresholds: [85, 70, 45, 20],
    icons: ['charge-l5', 'charge-l4', 'charge-l3', 'charge-l2', 'charge-low']
  },
  PHONE: {
    thresholds: [80, 60, 40, 20],
    icons: ['charge-l5', 'charge-l4', 'charge-l3', 'charge-l2', 'charge-low']
  }
}

const LOW_BATTERY_THRESHOLD = 20

export default {
  name: 'BatteryLevelIcon',
  components: {
    SvgIcon: () => import('@/components/SvgIcon.vue')
  },
  props: {
    type: {
      type: String,
      required: true,
      validator: (value) => ['DEVICE', 'PHONE'].includes(value)
    },
    level: {
      type: Number,
      required: false
    },
  },
  computed: {  
    chargeIcon() {
      return this.processBatteryData(this.level, this.type).icon
    },    
    levelText() {      
      return this.processBatteryData(this.level, this.type).lowChargeMessage      
    }
  },
  methods: {
    processBatteryData(charge, deviceType) {
      const config = BATTERY_CONFIG[deviceType]
      const isUnknown = !charge || charge <= 0

      if (isUnknown) {
        return {
          icon: 'charge-l5',
          lowChargeMessage: ''
        }
      }
      
      // Ищем в словаре иконку, соответствующую уровню заряда
      let levelIndex = config.thresholds.findIndex(t => charge > t)
      levelIndex = levelIndex === -1 ? config.icons.length - 1 : levelIndex

      return {
        icon: config.icons[levelIndex],
        lowChargeMessage: charge <= LOW_BATTERY_THRESHOLD ? `${charge}%` : null
      }
    },
  }
}
</script>
